import { oz } from '@weft/utils';
import type Stripe from 'stripe';

export const StripeGetCustomersResponseSchema = oz.object({ customers: oz.array(oz.custom<Stripe.Customer>()) }).openapi('getStripeCustomersResponse');

export type StripeGetCustomersResponse = oz.infer<typeof StripeGetCustomersResponseSchema>;